var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6154 28.4204C19.6154 29.6942 18.5816 30.315 17.3077 29.805L12.6923 27.9577C11.4185 27.4488 10.3846 26.0019 10.3846 24.7269V16.17L19.6154 13.8623V28.4204Z",
    fill: "#030104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6154 13.8623H10.3846L0 2.32381C0 1.04996 1.03385 0.0161133 2.30769 0.0161133H27.6923C28.9662 0.0161133 30 1.04996 30 2.32381L19.6154 13.8623Z",
    fill: "#030104"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineIcon);
export default __webpack_public_path__ + "static/media/PipelineIcon.eacba0324ff78e039ca4dfaa0c73386d.svg";
export { ForwardRef as ReactComponent };